import countdown from './countdown/index';
import mailchimpForm from './mailchimp/form';
import searchFormHeader from './searchform/header';
import woocommerceCheckout from './woocommerce/checkout';

countdown();
mailchimpForm();
searchFormHeader();
woocommerceCheckout();